import Utils from "../../../../../shared/utils"

export const IMAGE_URL = Utils.buildProductPageImageLink("mort/reduced-mort/first-section-desk.svg")

export const MAIN_TITLE_ICON = Utils.buildProductPageImageLink("icons/graph-house-icon.svg")